import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const { logo, title, description, linkText, linkText2, link, livelink, techStackUsed } = props;

	return (
		<React.Fragment>
			<div className="project">

				<div className="project-container">
					<div className="project-logo">
						<img src={logo} alt="logo" />
					</div>
					<div className="project-title">{title}</div>
					<div className="project-description">{description}</div>

					<div className="tech-stack" data-label="Tech Stack">{techStackUsed.techstack.map(elm =>
						<span key={elm}>{elm}</span>
					)}</div>

					<div className="tech-stack" data-label="Others">{techStackUsed.others.map(elm =>
						<span key={elm}>{elm}</span>
					)}</div>

					<div className="project-link">


						{link && <>
							<div className="project-link-icon">
								<FontAwesomeIcon icon={faLink} />
							</div><div className="project-link-text">{linkText}</div>
						</>}
						{
							livelink && <Link to={livelink}><div className="project-link-text">{linkText2}</div></Link>
						}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Project;
